export default {
  slug: "cpp-tools",
  code: "CPPT",
  label: "C++ Tools",
  logoFamily: "jb",
};
